module.exports = __webpack_public_path__ + "media/application/images/logo_v1-d2378fb34e4c680c6e9fd53b5d8d31eb.png";